// extracted by mini-css-extract-plugin
module.exports = {"module":"home_module__1axI-","content":"home_content__1m6Z8","item":"home_item__2ye6g"};